/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import { addQuery, createAbsoluteURL, sendRequest } from 'openvsx-webui';
import { Customer, UsageStatsList } from '../rate-limit-types';

// Bindings for the customers of the signed-in user under `/user/customers`; membership is
// checked by the server (403 for a non-member).

const endpoint = (serverUrl: string, ...segments: string[]): string =>
  createAbsoluteURL([serverUrl, 'user', 'customers', ...segments.map(encodeURIComponent)]);

export function getUserCustomers(serverUrl: string, signal: AbortSignal): Promise<Readonly<Customer[]>> {
  return sendRequest({ signal, credentials: true, endpoint: endpoint(serverUrl) });
}

export function getUserUsageStats(
  serverUrl: string,
  signal: AbortSignal,
  customerName: string,
  date: Date
): Promise<Readonly<UsageStatsList>> {
  return sendRequest({
    signal,
    credentials: true,
    endpoint: addQuery(endpoint(serverUrl, customerName, 'usage'), [{ key: 'date', value: date.toISOString() }])
  });
}
